import React from 'react';

import { FEATURE_FLAG } from '@qality/common-config';

type Props = {
  premium?: React.ReactChild;
  free?: React.ReactChild;
};

export default function PremiumFeatureGuard({
  premium,
  free,
}: Props): JSX.Element {
  return <>{FEATURE_FLAG.isPremium ? premium : free}</>;
}
